import {map} from 'lodash';
import {errorHandler} from 'utils/errorHandler';

const LOAD = 'server-sts/modules/LOAD';
const LOAD_SUCCESS = 'server-sts/modules/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/modules/LOAD_FAIL';
const EDIT_START = 'server-sts/modules/EDIT_START';
const EDIT_STOP = 'server-sts/modules/EDIT_STOP';
const SAVE = 'server-sts/modules/SAVE';
const SAVE_SUCCESS = 'server-sts/modules/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/modules/SAVE_FAIL';
const CREATE = 'server-sts/modules/CREATE';
const CREATE_SUCCESS = 'server-sts/modules/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/modules/CREATE_FAIL';

const DELETE = 'server-sts/modules/DELETE';
const DELETE_SUCCESS = 'server-sts/modules/DELETE_SUCCESS';
const DELETE_FAIL = 'server-sts/modules/DELETE_FAIL';

const initialState = {
  loaded: false,
  loading: false,
  created: false,
  moduleCreatedError:false,
  editing: {},
  saveError: {},
  saveSuccess:false
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: errorHandler(action.error)
      };

    case DELETE:
      return {
        ...state,
        loading: true
      };
    case DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.result.modules,
        error: null
      };
    case DELETE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };



    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };
    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveSuccess: false,
        saveError : {
        	...state.saveError,
        	[action.id]: null,
        }
      };

    case CREATE:
      return {
    		...state,
    		loading:true
    	};

    case CREATE_SUCCESS:
    	return {
				...state,
				created:true,
				loading:false,
				moduleCreatedError:false,
			};

    case CREATE_FAIL:
    	return {
				...state,
				created:false,
				loading:false,
				moduleCreatedError:errorHandler(action.error),
			};


    case SAVE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_SUCCESS:
      var modules = action.result.modules;
      return {
        data: modules,
        editing: {
          ...state.editing,
          [action.result.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.result.id]: null
        },
        saveSuccess: true,
        saveErrors: false
      };
    case SAVE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        },
        saveSuccess: false,
      } : state;
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.modules && globalState.modules.loaded;
}


export function createModule(values) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (module) => module.post('/module/create', {
      data: {
      	values
      }
    })
  };
}

export function load() {
  return {
    promise: (module) => module.post('/module/load'),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}

export function save(values) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (module) => module.post('/module/update', {
      data: {...values}
    })
  };
}

export function deleteModule(id) {
	
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (module) => module.post('/module/deleteModule', {
      data: {id}
    })
  };
}

export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}
